module.exports = __webpack_public_path__ + "img/esu.7cd8a16b.png";